import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name:'amountFormat'
})
export class AmountFormatPipe implements PipeTransform{
    transform(value: number | null | string): string {
        if (value !== null && value !== "" && value !==undefined) {
          const numericValue = Number(value);
          return numericValue === 0 ? "0" : numericValue.toFixed(2);
        } else {
          return '-';
        }
      }
}
